import {useLayoutEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
// @mui
import {alpha} from "@mui/material/styles";
import {Box, Divider, MenuItem, Stack, Typography} from "@mui/material";
// routes
import {PATH_AUTH, PATH_DASHBOARD} from "../../../routes/path";
// auth
import {useAuthContext} from "../../../auth/useAuthContext";
// components
import {CustomAvatar} from "../../../components/custom-avatar";
import {useSnackbar} from "notistack";
import MenuPopover from "../../../components/menu-popover";
import {IconButtonAnimate} from "../../../components/animate";
import {clearSession, getSessionOperator, removeSessionOperator} from "../../../helper/session";
import {findRoleName} from "../../../helper/other";
import {useDispatch} from "../../../redux/store";
import {useSelector} from "react-redux";
import {fetchAllUserLicense} from "../../../redux/slices/license";
import {fetchEsirBalance} from "../../../redux/slices/esirInvoices";
import moment from "moment/moment";

// ----------------------------------------------------------------------

const OPTIONS = [
    {
        label: "Početna",
        linkTo: "/"
    },
    {
        label: "Podešavanja",
        linkTo: PATH_DASHBOARD.general.settings
    }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const operator = getSessionOperator();

    const {balance} = useSelector((state => state.esirInvoices))
    const {licenses} = useSelector((state => state.license))

    const {logout} = useAuthContext();

    const {enqueueSnackbar} = useSnackbar();

    const [openPopover, setOpenPopover] = useState(null);

    useLayoutEffect(() => {
        dispatch(fetchAllUserLicense())
        dispatch(fetchEsirBalance())
    }, [])

    const handleOpenPopover = (event) => {
        setOpenPopover(event.currentTarget);
    };

    const handleClosePopover = () => {
        setOpenPopover(null);
    };

    const handleLogout = async () => {
        try {
            removeSessionOperator()
            navigate(PATH_AUTH.login, {replace: true});
            handleClosePopover();
        } catch (error) {
            console.error(error);
            enqueueSnackbar('Došlo je do greške!', {variant: 'error'});
        }
    };

    const handleClickItem = (path) => {
        handleClosePopover();
        navigate(path);
    };

    const  formatDateLicence = (prop) => {
        if (prop !== undefined && prop !== "") {
            return moment(prop).format('DD.MM.YYYY');
        } else {
            return "";
        }
    }

    return (
        <>
            <IconButtonAnimate
                onClick={handleOpenPopover}
                sx={{
                    p: 0,
                    ...(openPopover && {
                        "&:before": {
                            zIndex: 1,
                            content: "''",
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            position: "absolute",
                            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8)
                        }
                    })
                }}>
                <CustomAvatar src={operator?.photoURL} alt={operator?.username} name={operator?.username}/>
            </IconButtonAnimate>

            <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle2" noWrap>
                        {operator?.username}
                    </Typography>

                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                        {findRoleName(operator?.group)}
                    </Typography>
                </Box>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Stack sx={{ p: 1 }}>
                    {OPTIONS.map((option) => (
                        <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Stack>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Stack direction="row" spacing={3}>
                        <img alt="bank" style={{width: 25}} src={`/assets/banking-coin.svg`}/>
                        <Stack direction="column">
                            <Typography variant="caption" noWrap>Balans: {balance ?? 0}</Typography>
                            <Typography variant="caption">Trajanje licence: </Typography>
                            <Typography
                                variant="caption">{formatDateLicence(licenses.find(license => license.productID === 1)?.expiredDate.substring(0, 10))}</Typography>
                        </Stack>
                    </Stack>
                </Box>

                <Divider sx={{borderStyle: "dashed"}}/>

                <Divider sx={{ borderStyle: 'dashed' }} />

                <MenuItem onClick={handleLogout} sx={{ m: 1 }}>
                    Odjavi se
                </MenuItem>
            </MenuPopover>
        </>
    );
}